export function redirectToLogin() {

    var mainLanguageCode = $('#search_data').data('site_language');
    var siteCode = $('#search_data').data('site_code');

    var modal = $("#login_message_redirect_modal");
    if (modal.length) {
        modal.modal("show");
    } else {
        window.location.href = "/" + siteCode + "/" + mainLanguageCode + "/fix/login/";
    }
}